var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 0.5C19.9036 0.5 25.5 6.09644 25.5 13C25.5 19.9036 19.9036 25.5 13 25.5C6.09644 25.5 0.5 19.9036 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 0.5C19.9036 0.5 25.5 6.09644 25.5 13C25.5 19.9036 19.9036 25.5 13 25.5C6.09644 25.5 0.5 19.9036 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5Z",
  stroke: "#D20071"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 14H14V19C14 19.55 13.55 20 13 20C12.45 20 12 19.55 12 19V14H7C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12H12V7C12 6.45 12.45 6 13 6C13.55 6 14 6.45 14 7V12H19C19.55 12 20 12.45 20 13C20 13.55 19.55 14 19 14Z",
  fill: "#4A148C"
})));
export default SvgPlus;